import React, { Component } from "react";

import Grid from "@mui/material/Grid";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import CircularProgress from '@mui/material/CircularProgress';

import PageTitle from "components/PageTitle";
import PageDivider from "components/PageDivider";

import MDBadge from "components/MDBadge";
import MDTypography from "components/MDTypography";
import MDProgress from "components/MDProgress";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";

import FileSystemCommessa from "./fileSystemCommessa.js"
import SALCommessa from "./sal.js"
import SALCommessaQuadro from "./salQuadro.js"
import DataAndCalendar from "./dataAndCalendar.js"
import OrdiniCommessa from "./ordiniCommessa.js"
import ManodoperaCommessa from "./manodoperaCommessa.js"
import PreventiviCommessa from "./preventiviCommessa.js"
import PreventiviCommessaGroup from "./preventiviCommessaGroup.js"
import FattureCommessa from "./fattureCommessa.js"

import * as ajax from "helpers/ajax";

import MapContainer from "components/GoogleMap";
import DoughnutChart from "components/DoughnutChart";

import Modal from '@mui/material/Modal';
import { Link } from "react-router-dom";
import { DropzoneDialog } from 'material-ui-dropzone';

import { FATTURE_COMPANY_ID } from "constant";
import { getAQPassedDays, isAccordoQuadro, toPrice, calculateSAL, calculateSALHierarchical, getWorkedDaysNumber, laborCostCommessa } from "helpers/functions.js"

import MyDataTable from "components/DataTable";
import tableData from "DBTables/incarichi.json"
import { ROLES } from "constant"
import { CHECKLIST_COMMESSA } from "../../constant.js";

import  DettaglioGara2  from "./../gare/dettaglioGara.js";
import CheckList from "../../components/CheckList/index.js";
import { CheckListCommessa } from "../../components/CheckListCommessa/index.js";

const size = 120,
    thickness = 9,
    secColor = '#EF5350';

const progressCircle = {
    borderRadius: '50%',
    boxShadow: `inset 0 0 0 ${thickness / 44 * size}px ${secColor}`,
    color:"#1A73E8"
};



export default class DettaglioGara extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,

            listOperai: [],
            listOperaiCosti: [],

            listPreventivi: [],
            listFatture:[],

            openFileSystem: false,
            openSAL: false,
            openOrdini: false,
            openMaodopera: false,
            openPreventivi: false,
            openFatture:false,

            openOperai: false,

            openCel: false,
            openRifiuti:false,

            openGara:false,

            sal: 0,

            salList: [[]],

            FCData:[],


            openSubFileSystem: false,
            subFileSystemSelected:null
        };

        this.FCDataTemp = [];
    }


    componentDidMount = () => {
        if (isAccordoQuadro(this.state.data)) {
            this.loadSALQuadro()
        } else {
            this.loadSAL()
        }
        this.loadOperai();
        this.loadOperaiCosti();

        let formdata = new FormData();

        formdata.append("name", this.state.data.nome);
        ajax.ajaxPost("/FC_getFattureCommessa.php", formdata, this.costCallback)



        this.loadPreventivi();
        this.loadFatture();

    }

    loadPreventivi = () => {
        ajax.ajaxGetStrapi("preventivis?filters[commessa][id]=" + this.state.data.id + "&filters[accettato][$eq]=Accettato", (response) => {
            this.setState({ listPreventivi: response.data })
        })
    }

    loadFatture = () => {
        ajax.ajaxGetStrapi("fattures?filters[commessa][id]=" + this.state.data.id, (response) => {
            this.setState({ listFatture: response.data })
        })
    }

    reload = () => {
        this.loadPreventivi();
        this.loadFatture();
    }

    costCallback = (response) => {

        response.message.map((el) => {
            this.FCDataTemp.push(el);
        })

        let data = this.state.data;
        data["fc_ordini"] = this.FCDataTemp;
        this.setState({ data: data })

        let formdata = { data: { fc_ordini: this.FCDataTemp } }
        ajax.ajaxPutStrapi("commessas/" + this.state.data.id, formdata)
    }


    uploadFiles = (files) => {
        let formData = new FormData();
        let path = "/commessa/" + this.state.data.id + "/";

        if (this.state.openCel) { path += "CEL" }
        if (this.state.openRifiuti) { path += "Formulario rifiuti" }

        formData.append("path", path);
        files.map((file, index) => {
            formData.append("file[]", file);
        })


        ajax.ajaxPost("/file_upload.php", formData, this.downloadFiles)


        if (this.state.openCel) {
            let formdata = {
                data: { stato: "finito" }
            }
            ajax.ajaxPutStrapi("commessas/" + this.state.data.id, formdata)
        }
    }


    loadOperai = () => {

        let url = "operai-commesses?populate=operaio.societa&populate=*&filters[commessa][id]=" + this.state.data.id;

        if (isAccordoQuadro(this.state.data)) {
            url = "operai-commesses?populate=operaio.societa&populate=*";
            this.state.data.incarichi.map((el, index) => {
                url += "&filters[commessa][id][$in][" + index + "]=" + el.id;
            })
        } 

        ajax.ajaxGetStrapi(url, (workerResponse) => {
            let temp = [];
            workerResponse.data.map((el) => {
                if (!el || !el.operaio) { return; }
                for (let i = 0; i < temp.length; i++) {
                    if (temp[i].operaio && temp[i].operaio.id == el.operaio.id) {
                        return
                    }
                }
                temp.push(el);
            })

            this.setState({ listOperai: temp })
        })
    }

    loadOperaiCosti = () => {
        let url = "operai-commesses?sort[0]=data&populate=operaio.societa&populate=*&filters[commessa][id]=" + this.state.data.id;

        if (isAccordoQuadro(this.state.data)) {
            url = "operai-commesses?sort[0]=data&populate=operaio.societa&populate=*";
            this.state.data.incarichi.map((el, index) => {
                url += "&filters[commessa][id][$in][" + index + "]=" + el.id;
            })
        } 
        ajax.ajaxGetStrapi(url, (workerResponse) => {
            this.setState({ listOperaiCosti: workerResponse.data })
        })
    }


    openFileSystem = () => {
        this.setState({ openFileSystem: true });
    }

    openSubFileSystem = (data) => {
        this.setState({ openSubFileSystem: true,subFileSystemSelected:data });
    }

    loadSAL = () => {
        ajax.ajaxGetStrapi("sal-commessas?filters[commessa][id][$eq]=" + this.state.data.id + "&sort=id&populate=parent", this.loadSALCallback)
    }

    loadSALCallback = (response) => {
        this.setState({ sal: calculateSALHierarchical(response.data)  })
    }

    loadSALQuadro = () => {
        this.state.data.incarichi.map((el, index) => {
            let url = "sal-commessas?filters[commessa][id][$eq]=" + el.id + "&sort=id&populate=parent";
            ajax.ajaxGetStrapi(url, (response) => {
                this.loadSALQuadroCallback(response, index)
            })
        })

    }

    loadSALQuadroCallback = (response, index) => {
        let temp = this.state.data.incarichi;
        temp[index].sal = response.data;
        this.setState({ salList: temp, sal: this.calculateSalQuadro() })
    }

    calculateSalQuadro = () => {
        let totalIncidenza = 0;
        let totalWeightedPercentage = 0;

        // First calculate total incidenza
        this.state.salList.forEach((el) => {
            if (!el.sal) { el.sal = [] }
            if (!el.incidenza) { el.incidenza = 0 }
            totalIncidenza += parseFloat(el.incidenza) || 0;
        });

        // Calculate weighted average with normalization
        this.state.salList.forEach((el) => {
            const incidenza = parseFloat(el.incidenza) || 0;
            const salPercentage = calculateSALHierarchical(el.sal);
            
            // Normalize incidenza to percentage of total
            const normalizedIncidenza = totalIncidenza > 0 ? (incidenza / totalIncidenza) * 100 : 0;
            
            totalWeightedPercentage += (salPercentage * normalizedIncidenza / 100);
        });

        return totalWeightedPercentage;
    }

    openSAL = () => {
        this.setState({ openSAL: true });
    }


    calculateMissingDay = () => {

    }

    convertDate = (date) => {
        var yyyy = date.getFullYear().toString();
        var mm = (date.getMonth() + 1).toString();
        var dd = date.getDate().toString();

        var mmChars = mm.split('');
        var ddChars = dd.split('');

        return yyyy + '-' + (mmChars[1] ? mm : "0" + mmChars[0]) + '-' + (ddChars[1] ? dd : "0" + ddChars[0]);
    }



    renderRigaPreventivi = (el, index, last = false) => {
        return (
            <Grid container sx={{ borderBottom: (last) ? "none" : "1px solid #00000080", marginBottom: "10px", paddingBottom: "10px" }}>
                <Grid item sm={4}>
                    <MDTypography variant={"body2"}>{el.action}</MDTypography>
                </Grid>
                <Grid item sm={4}>
                    <MDTypography variant={"body2"}>{el.company}</MDTypography>
                </Grid>
                <Grid item sm={4}>
                    <MDTypography variant={"body2"}>{toPrice(el.price)}</MDTypography>
                </Grid>
            </Grid>
        )
    }

    renderRigaFatture = (el, index, last = false) => {
        return (
            <Grid container sx={{ borderBottom: (last) ? "none" : "1px solid #00000080", marginBottom: "10px", paddingBottom: "10px" }}>
                <Grid item sm={4}>
                    <MDTypography variant={"body2"}>{el.number}</MDTypography>
                </Grid>
                <Grid item sm={4}>
                    <MDTypography variant={"body2"}>{el.avanzamento}</MDTypography>
                </Grid>
                <Grid item sm={4}>
                    <MDTypography variant={"body2"}>{toPrice(el.imponibile*(1+(el.iva/100)))}</MDTypography>
                </Grid>
            </Grid>
        )
    }

    renderRigaOperai = (name, role, agency, last = false) => {
        return (
            <Grid key={name} container sx={{ borderBottom: (last) ? "none" : "1px solid #00000080", marginBottom: "10px", paddingBottom: "10px" }}>
                <Grid item sm={4}>
                    <MDTypography variant={"body2"}>{name}</MDTypography>
                </Grid>
                <Grid item sm={4}>
                    <MDTypography variant={"body2"}>{role}</MDTypography>
                </Grid>
                <Grid item sm={4}>
                    <MDTypography variant={"body2"}>{agency}</MDTypography>
                </Grid>
            </Grid>
        )
    }

    totalDuration = () => {
        let duration = this.state.data.durata;
        let duration2 = this.state.data.proroga;

        if (isNaN(parseInt(duration))) {
            duration = 0;
        }
        if (isNaN(parseInt(duration2))) {
            duration2 = 0;
        }

        return parseInt(duration) + parseInt(duration2);
    }

    getBusinessDatesCount = (startDate, duration, returnType = "endDate") => {
        if (!startDate) {
            return 0
        }

        let count = 0;
        let workedDays = 0;

        const curDate = new Date(startDate);
        const endDate = new Date(startDate)
        endDate.setDate(endDate.getDate() + duration);

        while (curDate <= endDate) {
            const dayOfWeek = curDate.getDay();
            if (dayOfWeek !== 0 && dayOfWeek !== 6) {
                count++;
                if (new Date() > curDate) {
                    workedDays++;
                }
            } else {
                //festivi
                endDate.setDate(endDate.getDate() + 1);
            }
            curDate.setDate(curDate.getDate() + 1);
        }

        switch (returnType) {
            case "endDate": return endDate;
            case "workingDays": return workedDays;
        }

        return endDate;
    }

    openCel = () => {
        this.setState({ openCel: true })
    }

    openRifiuti = () => {
        this.setState({ openRifiuti: true })
    }

    sumOrder = () => {
        let n = 0;

        if (isAccordoQuadro(this.state.data)) {
            this.state.data.incarichi.map((incarico) => {
                if (!incarico.fc_ordini) { return }
                incarico.fc_ordini.map((el) => { n += el.amount_gross })
            })
            return n.toFixed(2);
        }

        if (!this.state.data.fc_ordini) {return 0}
        this.state.data.fc_ordini.map((el) => { n+=el.amount_gross})

        return n.toFixed(2)
    }

    orderPercentage = () => {
        if (!this.state.data.costo_ordini) { return 0 }

        let n = ((this.sumOrder() * 100) / this.state.data.costo_ordini).toFixed(2); 
        if (n > 100) { return 100}
        return n
    }

    sumWorkerCost = () => {
        let n = 0;
        this.state.listOperaiCosti.map((el) => {
            if (!el.operaio) {return}
            if (el.stato == "STRAORDINARI ") { n += el.operaio.costo_straordinario*el.ore }
            if (el.stato == "ORDINARIO") { n += el.operaio.costo_orario*el.ore }
        })

        return n.toFixed(2);
    }

    workerCostPercetage = (tot) => {
        if (!this.state.data.costo_manodopera) { return 0 }

        let n = ((tot * 100) / this.state.data.costo_manodopera).toFixed(2);
        if (n > 100) { return 100 }
        return n

    }



    deleteWorkers = (data) => {
        let id = [];
        global.workers.data.map((el) => {
            if (el.commessa) {
                if (el.commessa.id == data.data.id) {
                    id.push(el.id)
                }
            }

        })

        id.map((el) => {
            ajax.ajaxDeleteStrapi("operai-commesses/" + el)
        })
    }

    createFileSystem = (data) => {
        let formData = new FormData();
        formData.append("id", data.data.id)
        ajax.ajaxPost("/file_create_commessa.php", formData)

        if(isAccordoQuadro(this.state.data)){
            this.state.data.incarichi.map((el, index) => {
                if (el.id == data.data.id) {
                    let temp = this.state.data;
                    temp.incarichi[index].costo_manodopera = data.data.costo_manodopera
                    temp.incarichi[index].costo_ordini = data.data.costo_ordini
                    this.setState({data:temp})
                }
            })
        }

        this.mapRef.load();
    }

    openFileSystem = (data) => {
        this.setState({ openFileSystem: true, commessaSelected: data });
    }

    createChecklist = (data) => {
        CHECKLIST_COMMESSA.map((el) => {
            let formdata = {}
            formdata["name"] = el.name;
            formdata["type"] = el.type;
            formdata["commessa"] = data.data.id;
            formdata = { "data": formdata };
            ajax.ajaxPostStrapi("commessa-checklists", formdata)
        })
    }

    openDetail = (data) => {
        // Assicurati che data abbia sempre commessa_checklists come array
        if (!data.commessa_checklists) {
            data.commessa_checklists = [];
        }
        this.setState({ openIncarico: true, commessaSelected: data });
    }


    costoOrdiniAQ = () => {
        let n = 0;
        this.state.data.incarichi.map((incarico) => {
            n += incarico.costo_ordini;
        })
        return n
    }

    costoManodoperaAQ = () => {
        let n = 0;
        this.state.data.incarichi.map((incarico) => {
            n += incarico.costo_manodopera;
        })
        return n
    }

    checklistOnChange = (data) => {
        let temp = this.state.data;
        let index = temp.commessa_checklists.findIndex(x => x.id === data.id);
        temp.commessa_checklists[index] = data;
        this.setState({ data: temp })
    }




    render() {
        if (this.state.openOrdini) {
            return <OrdiniCommessa orders={this.state.FCData} data={this.state.data} backFunction={() => this.setState({ openOrdini: false })} />
        }
        if (this.state.openMaodopera) {
            return <ManodoperaCommessa workers={this.state.listOperaiCosti} data={this.state.data} backFunction={() => this.setState({ openMaodopera: false })} />
        }
        if (this.state.openPreventivi) {
            return <PreventiviCommessaGroup orders={this.state.FCData} data={this.state.data} backFunction={() => this.setState({ openPreventivi: false }, this.reload)} />
        }
        if (this.state.openFatture) {
            return <FattureCommessa data={this.state.data} backFunction={() => this.setState({ openFatture: false }, this.reload)} />
        }

        if (this.state.openFileSystem) {
            return <FileSystemCommessa data={this.state.data} backFunction={() => this.setState({ openFileSystem: false })} />
        }

        if (this.state.openSubFileSystem) {
            return <FileSystemCommessa data={this.state.subFileSystemSelected} backFunction={() => this.setState({ openSubFileSystem: false })} />
        }

        if (this.state.openSAL) {
            if (isAccordoQuadro(this.state.data)) {
                return <SALCommessaQuadro data={this.state.data} backFunction={() => { this.setState({ openSAL: false }); this.loadSALQuadro() }} />
            } else {
                return <SALCommessa data={this.state.data} backFunction={() => { this.setState({ openSAL: false }); this.loadSAL() }} />
            }
        }

            if (this.state.openIncarico) {
                return <DettaglioGara data={this.state.commessaSelected} backFunction={() => { this.setState({ openIncarico: false }); }} />
            }

            if (this.state.openGara) {
                return <DettaglioGara2 data={this.state.openGara} backFunction={() => { this.setState({ openGara: false }); }} />
            }

        let workerCost = laborCostCommessa(this.state.listOperaiCosti, null, null, this.state.data.id)
        let workerCostPercentage = this.workerCostPercetage(workerCost)
        let totalDuration = this.totalDuration();
            let workedDays = getWorkedDaysNumber(this.state.listOperaiCosti)
            if (isAccordoQuadro(this.state.data)) {
                workedDays = getAQPassedDays(this.state.data);
            }

            if (workedDays > totalDuration) { workedDays = totalDuration; }

        let name = "";
        let subname = "";
        if (this.state.data.commessa_madre) {
            name = "Commessa - " + this.state.data.commessa_madre.nome
            subname="Incarico - "+ this.state.data.nome
        } else {
            name = "Commessa - " + this.state.data.nome
            subname = "";
        }

        /*
        this.state.data.commessa_checklists.sort(function (a, b) {
            return a.id - b.id;
        });
*/

        return (
            <DashboardLayout>
                <DashboardNavbar />
                <PageTitle
                    text={name}
                    subtitle={subname}
                    backButton={this.props.backFunction}
                    menu={[{ label: "Carica CEL", function: this.openCel }, { label: "Carica Formulario Rifiuti", function: this.openRifiuti }]}
                />

                <DataAndCalendar
                    ref={(ref) => this.mapRef = ref}
                    id={this.state.data.id}
                    onChange={(data) => { this.setState({ data: data }) }}
                    openGara={(data) => this.setState({ openGara: data })}
                    gara={this.state.data.gara}
                    sal={(
                        <Grid container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Grid item sm={8} md={9} pt={1}>
                                <MDProgress sx={{ backgroundColor: "white!important", marginBottom: 5 }} value={this.state.sal} variant="gradient" color={"info"} label />
                            </Grid>
                            <Grid item sm={4} md={3}>
                                <MDButton variant="text" color="info" onClick={() => { this.openSAL() }}>Dettagli {">"}</MDButton>
                            </Grid>
                        </Grid>
                    )}
                />

                <Grid container>

                    {/*INCARICHI*/}
                    {isAccordoQuadro(this.state.data) ?
                        <Grid item sm={12}>
                            <PageDivider text="Incarichi" />
                            <MyDataTable
                                commessaID={this.state.data.id}
                                tableData={tableData}
                                filters={"&filters[commessa_madre]=" + this.state.data.id + "&populate=preventivis&populate=fattures&populate=gara&populate=commessa_madre&populate=commessa_checklists"}
                                edit={[ROLES.admin, ROLES.ufficio_tecnico, ROLES.PM].includes(global.user.ruolo) ? true : false}
                                editCondition={(row) => row.stato != "finito"}
                                delete={[ROLES.admin, ROLES.ufficio_tecnico, ROLES.PM].includes(global.user.ruolo) ? true : false}
                                add={[ROLES.admin, ROLES.ufficio_tecnico, ROLES.PM].includes(global.user.ruolo) && this.state.data.stato != "finito" ? true : false}
                                icon={"Personale"}
                                onDelete={(data) => this.deleteWorkers(data)}
                                onEdit={(data) => this.createFileSystem(data)}
                                onNew={(data) => { this.createFileSystem(data); this.createChecklist(data) }}
                                customAction={[
                                    {
                                        icon: "visibility",
                                        function: this.openDetail
                                    },
                                    {
                                        icon: "folder",
                                        color: "info",
                                        function: this.openSubFileSystem
                                    }
                                ]}
                            />

                        </Grid>
                        : null
                    }

                    {/*OPERAI*/}

                    <Grid item sm={12} md={6} pr={2}>
                        <PageDivider text="Operai" />
                        {this.state.listOperai.map((el, index) => {
                            if (index > 2) { return null }
                            if (!el || !el.operaio) { return null }
                            return this.renderRigaOperai(el.operaio.nome + " " + el.operaio.cognome, el.operaio.mansione, el.operaio.societa ? el.operaio.societa.nome : "", index == 2 ? true : false)
                        })}

                        <MDButton sx={{ float: "right" }} variant="text" color="info" onClick={() => { this.setState({ openOperai: true }) }}>Dettagli {">"}</MDButton>

                    </Grid>


                    <Modal
                        open={this.state.openOperai}
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        onClose={() => this.setState({ openOperai: false })}
                        style={{
                            margin: "auto", display: "flex", alignItems: "center", justifyContent: "center"
                        }}
                    >

                        <MDBox
                            bgColor={"white"}
                            borderRadius="lg"
                            p={2}
                            minWidth={400}
                            sx={{ maxHeight: "90%", overflow: "auto" }}
                        >
                            <MDBox
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                                mx={2}
                                mt={-3}
                                p={2}
                                mb={1}
                                textAlign="center"
                            >
                                <MDTypography variant="h2" fontWeight="medium" color="white" mt={1}>
                                    Operai
                            </MDTypography>
                            </MDBox>

                            <Grid p={4}>
                                {this.state.listOperai.map((el, index) => {
                                    if (!el || !el.operaio) { return null }
                                    return this.renderRigaOperai(el.operaio.nome + " " + el.operaio.cognome, el.operaio.mansione, el.operaio.societa ? el.operaio.societa.nome : "", index == this.state.listOperai.length - 1 ? true : false)
                                })}
                            </Grid>
                            {this.state.data.stato != "finito" ? 

                            <Grid container>
                                <Grid item xs pr={1}>
                                    <MDButton fullWidth color="info" sx={{ padding: "0px!important" }}>
                                        <Link style={{ color: "white", padding: 12 }} to={"../gestione-attivita?id=" + this.state.data.id}>diario cantiere</Link>
                                    </MDButton>
                                </Grid>
                                    <Grid item xs pr={1}>
                                        <MDButton fullWidth color="dark" sx={{ padding: "0px!important" }}>
                                            <Link style={{ color: "white", padding: 12 }} to={"../gestione-operai?id=" + this.state.data.id}>gestione manodopera</Link>
                                        </MDButton>
                                    </Grid>
                            </Grid>
                                : null}

                        </MDBox>
                    </Modal>

                    {/*FINE OPERAI*/}

                    {/*TEMPISTICHE*/}

                    <Grid item sm={12} md={6} pr={2}>
                        <Grid container>
                            <Grid item sm={12}>
                                <PageDivider text={"Tempistiche"} />
                            </Grid>
                            <Grid container
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Grid item sm={6}>
                                    <MDTypography variant={"h4"}>
                                        {totalDuration} <MDTypography variant={"button"} >Giorni TOTALI</MDTypography>
                                    </MDTypography>
                                    <MDTypography variant={"h4"}>
                                        {workedDays} <MDTypography variant={"button"} >{isAccordoQuadro(this.state.data) ? "Giorni PASSATI" : "Giorni LAVORATI"}</MDTypography>
                                        {"   "}<MDBadge color={"info"} badgeContent={" "} container indicator />
                                    </MDTypography>
                                    <MDTypography variant={"h4"}>
                                        {totalDuration - workedDays} <MDTypography variant={"button"} >Giorni MANCANTI</MDTypography>
                                        {"   "}<MDBadge color={"error"} badgeContent={" "} container indicator />
                                    </MDTypography>
                                </Grid>
                                <Grid item sm={6}>
                                    <DoughnutChart
                                        data={{
                                            labels: ["Giorni lavorati", "Giorni mancanti"],
                                            datasets: [
                                                {
                                                    label: 'Giorni Lavorati',
                                                    data: [workedDays, totalDuration - workedDays],
                                                    backgroundColor: ["#1A73E8", "#EF5350"],
                                                    borderWidth: 0
                                                }
                                            ]

                                        }}
                                    />
                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>
                    {/*FINE TEMPISTICHE*/}

                </Grid>

                {/*ORDINI*/}
                <PageDivider text="Ordini" />
                <Grid container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                >           

    
                    <Grid item sm={12} md={3}>
                        <DoughnutChart
                            priceMode={true}
                            data={{
                                labels: ["Costo totale ad oggi", "Costi preventivati"],
                                datasets: [
                                    {
                                        data: [this.sumOrder(), isAccordoQuadro(this.state.data) ? parseInt(this.costoOrdiniAQ()).toFixed(2) : this.state.data.costo_ordini ? parseInt(this.state.data.costo_ordini).toFixed(2) : 0],
                                        backgroundColor: ["#1A73E8", "#EF5350"],
                                        borderWidth: 0
                                    }
                                ]

                            }}
                        />

                    </Grid>
                    <Grid item sm={4} md={3}>
                        <MDTypography variant={"h5"}>{toPrice(this.sumOrder())}</MDTypography>
                        <MDTypography variant={"overline"}>Costo totale ad oggi</MDTypography>
                    </Grid>
                    <Grid item sm={4} md={3}>
                        <MDTypography variant={"h5"}>{isAccordoQuadro(this.state.data) ? toPrice(parseInt(this.costoOrdiniAQ()).toFixed(2)) :this.state.data.costo_ordini ? toPrice(parseInt(this.state.data.costo_ordini).toFixed(2)) : toPrice((0).toFixed(2))}</MDTypography>
                        <MDTypography variant={"overline"}>Preventivati</MDTypography>
                    </Grid>
                    <Grid item sm={4} md={3}>
                        <MDButton variant="text" color="info" onClick={() => { this.setState({ openOrdini: true }) }}>Dettagli {">"}</MDButton>
                    </Grid>
                </Grid>
                {/*FINE ORDINI*/}

                {/*MANODOPERA*/}
                <PageDivider text="Costo manodopera" />
                <Grid container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Grid item sm={12} md={3}>
                        <DoughnutChart
                            priceMode={true}
                            data={{
                                labels: ["Costo totale ad oggi", "Costi preventivati"],
                                datasets: [
                                    {
                                        data: [workerCost, isAccordoQuadro(this.state.data) ? parseInt(this.costoManodoperaAQ()).toFixed(2) : this.state.data.costo_manodopera ? parseInt(this.state.data.costo_manodopera).toFixed(2) : 0],
                                        backgroundColor: ["#1A73E8", "#EF5350"],
                                        borderWidth: 0
                                    }
                                ]

                            }}
                        />                

                    </Grid>
                    <Grid item sm={4} md={3}>
                        <MDTypography variant={"h5"}>{toPrice(workerCost)}</MDTypography>
                        <MDTypography variant={"overline"}>Costo totale ad oggi</MDTypography>
                    </Grid>
                    <Grid item sm={4} md={3}>
                        <MDTypography variant={"h5"}>{isAccordoQuadro(this.state.data) ? toPrice(parseInt(this.costoManodoperaAQ()).toFixed(2)) :this.state.data.costo_manodopera ? toPrice(parseInt(this.state.data.costo_manodopera).toFixed(2)) : toPrice((0).toFixed(2))}</MDTypography>
                        <MDTypography variant={"overline"}>Preventativi</MDTypography>
                    </Grid>
                    <Grid item sm={4} md={3}>
                        <MDButton variant="text" color="info" onClick={() => { this.setState({ openMaodopera: true }) }}>Dettagli {">"}</MDButton>
                    </Grid>
                </Grid>
                {/*FINE MANODOPERA*/}


                {isAccordoQuadro(this.state.data) ? null :
                    <>
                        {/*Fatture*/}
                        <PageDivider text="Fatture emesse" />
                        <Grid container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Grid item sm={8} md={9}>
                                {this.state.listFatture.slice(-3).map((el, index) => { return this.renderRigaFatture(el, index, index == this.state.data.fattures.slice(-3).length - 1 ? true : false) })}
                            </Grid>
                            <Grid item sm={4} md={3}>
                                <MDButton variant="text" color="info" onClick={() => { this.setState({ openFatture: true }) }}>Dettagli {">"}</MDButton>
                            </Grid>
                        </Grid>
                        {/*FINE fatture*/}


                        {/*PREVENTIVI*/}
                        <PageDivider text="Preventivi" />
                        <Grid container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Grid item sm={8} md={9}>
                                {this.state.listPreventivi.slice(-3).map((el, index) => { return this.renderRigaPreventivi(el, index, index == this.state.data.preventivis.slice(-3).length - 1 ? true : false) })}
                            </Grid>
                            <Grid item sm={4} md={3}>
                                <MDButton variant="text" color="info" onClick={() => { this.setState({ openPreventivi: true }) }}>Dettagli {">"}</MDButton>
                            </Grid>
                        </Grid>
                    </>
                }
                {/*FINE PREVENTIVI*/}

                {/*DOCUMENTAZIONE*/}
                <PageDivider text="DOCUMENTAZIONE DI FINE LAVORI" />

                    {this.state.data.commessa_checklists.map((el, index) => {
                        const shouldHideDocumentation = el.name === "Certificato di Esecuzione Lavori (CEL)" || el.name === "Modulo di fine cantiere";
                        return (
                            <CheckListCommessa
                                key={"checklist-" + index}
                                data={el}
                                onChange={(data) => this.checklistOnChange(data)}
                                id={this.state.data.id}
                                openFileSystem={() => this.openFileSystem()}
                                subfolder={el.name}
                                hideDocumentation={shouldHideDocumentation}
                                disabled={this.state.data.stato === "finito"}
                            />
                        )
                    })}
                
                {/*FINE DOCUMENTAZIONE*/ }



                {/*UPLOAD DOC*/}
                <DropzoneDialog
                    cancelButtonText={"Annulla"}
                    submitButtonText={"Invia"}
                    open={this.state.openCel || this.state.openRifiuti}
                    onClose={() => this.setState({ openCel: false, openRifiuti: false })}
                    onSave={(files) => {
                        this.uploadFiles(files)
                        this.setState({ openCel: false, openRifiuti: false })
                    }}
                    showPreviews={true}
                    showFileNamesInPreview={true}
                    filesLimit={10}
                />
                {/*FINE UPLOAD DOC*/}


            </DashboardLayout>
        )
    }
}


